import { useEffect } from 'react';

/**
 * モーダル表示時に背景のスクロールを無効化するカスタムフック
 */
export const useDisableBodyScroll = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
};
